export default function DentalCare() {
  return (
    <section className="py-24 lg:py-32 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/b148e62d10893bb5487e1816040923fd.jpg"
                  alt="Dental Care"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              
              {/* Floating Card */}
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full">
                    <i className="ri-check-line text-2xl text-amber-700"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">100+</div>
                    <div className="text-xs text-gray-600">덴탈케어 제품</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2">
            <p className="text-xs font-semibold text-amber-700 tracking-widest uppercase mb-4">
              DENTAL CARE EXPANSION
            </p>
            
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              화장품을 넘어<br />
              덴탈케어까지
            </h2>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              칫솔 전문 공장 및 치약 제조 공장과의 전략적 제휴를 통해 구강용품까지 사업 영역을 확장하여, 화장품과 덴탈케어 제품을 아우르는 통합 생산·공급 체계를 구축하고 있습니다.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 mb-1">칫솔 전문 공장 제휴</h3>
                  <p className="text-sm text-gray-600">최신 설비를 갖춘 전문 공장과의 협력으로 다양한 칫솔 제품 생산</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 mb-1">치약 제조 공장 제휴</h3>
                  <p className="text-sm text-gray-600">기능성 치약부터 천연 치약까지 폭넓은 제품 라인업</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-checkbox-circle-fill text-xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 mb-1">통합 생산 체계</h3>
                  <p className="text-sm text-gray-600">화장품과 덴탈케어 제품의 원스톱 생산 및 공급</p>
                </div>
              </div>
            </div>

            {/* Removed button */}
          </div>
        </div>
      </div>
    </section>
  );
}
